/**
 * Haalt de inhoud van een publieke pagina op, met de tekst uit de code als terugval.
 * Met ?voorvertoning=1 toont de pagina het concept — enkel zichtbaar voor wie is aangemeld.
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { adminPageQuery, publishedPageQuery } from "@/lib/content-queries";
import { pageContent, type PageContent } from "@/lib/page-content";

export function usePageContent(sleutel: string, lang: string, voorvertoning?: "1"): PageContent {
  const { data: gepubliceerd } = useSuspenseQuery(publishedPageQuery(sleutel, lang));
  const concept = useQuery({ ...adminPageQuery(sleutel, "nl"), enabled: voorvertoning === "1" });
  return pageContent(voorvertoning === "1" ? (concept.data ?? gepubliceerd) : gepubliceerd);
}

/** Leest de voorvertoningsvlag uit de zoekbalk. */
export function validateVoorvertoning(search: Record<string, unknown>): { voorvertoning?: "1" } {
  return search["voorvertoning"] === "1" ? { voorvertoning: "1" } : {};
}
